var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 88,
    viewBox: "0 0 70 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 64.5193L34.6667 77.5193V9.20866H8.66667V64.5193ZM8.66667 0.541992H60.6667C62.9652 0.541992 65.1696 1.45508 66.7949 3.0804C68.4202 4.70571 69.3333 6.91012 69.3333 9.20866V69.8753L34.6667 87.2086L0 69.8753V9.20866C0 6.91012 0.913092 4.70571 2.53841 3.0804C4.16372 1.45508 6.36812 0.541992 8.66667 0.541992Z",
    fill: "url(#paint0_linear_1_150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_150",
    x1: -16.4014,
    y1: 87.2086,
    x2: 153.018,
    y2: 87.2086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.45a0980fd8c63c8436e6e4085f4f0512.svg";
export { ForwardRef as ReactComponent };